const _tableImport = {
    excleHead: [
        {
            title: "Status Import",
            dataIndex: "status_import",
            scopedSlots: { customRender: "status_import" },
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },
        {
            title: "Status Import Detail",
            dataIndex: "status_detail",
            scopedSlots: { customRender: "status_detail" },
            width: 150,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },        
        {
            title: "Student_ID",
            dataIndex: "student_id",
            key: "student_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Name of Awards/Scholarship",
            dataIndex: "name_of_award_scholarship",
            scopedSlots: { customRender: "name_of_award_scholarship" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Date of Receive",
            dataIndex: "date_of_recive",
            scopedSlots: { customRender: "date_of_recive" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        },{
            title: "Organized by/Granted by",
            dataIndex: "organized_by_granted_by",
            width: 100,
            scopedSlots: { customRender: "organized_by_granted_by" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Location",
            dataIndex: "location_and_country",
            width: 100,
            scopedSlots: { customRender: "location_and_country" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Type of award",
            dataIndex: "type_award",
            width: 100,
            scopedSlots: { customRender: "type_award" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },

    ],
}

export default _tableImport;
